// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCache } from '../DataCache';
import { EventEmitter } from 'events';
export class IdeasSideBarController {
    constructor() {
        this._eventEmitter = new EventEmitter();
    }
    subscribe() {
        DataCache.OnTradingIdeaAdd.Subscribe(this.addIdea, this);
        DataCache.OnTradingIdeaCancel.Subscribe(this.cancelIdea, this);
        DataCache.OnTradingSystemsChange.Subscribe(this.systemsChange, this);
        DataCache.OnTradingSystemUnsubscribe.Subscribe(this.systemUnsubscribe, this);
    }
    unsubscribe() {
        DataCache.OnTradingIdeaAdd.UnSubscribe(this.addIdea, this);
        DataCache.OnTradingIdeaCancel.UnSubscribe(this.cancelIdea, this);
        DataCache.OnTradingSystemsChange.UnSubscribe(this.systemsChange, this);
        DataCache.OnTradingSystemUnsubscribe.UnSubscribe(this.systemUnsubscribe, this);
    }
    // subscribe
    subscribeToAdd(callback) {
        this._eventEmitter.on('add', callback);
    }
    subscribeToCancel(callback) {
        this._eventEmitter.on('cancel', callback);
    }
    subscribeToSystemsChange(callback) {
        this._eventEmitter.on('change', callback);
    }
    subscribeToSystemUnsubscribe(callback) {
        this._eventEmitter.on('unsubscribe', callback);
    }
    // unsubscribe
    unsubscribeToAdd(callback) {
        this._eventEmitter.off('add', callback);
    }
    unsubscribeToCancel(callback) {
        this._eventEmitter.off('cancel', callback);
    }
    unsubscribeToSystemsChange(callback) {
        this._eventEmitter.off('change', callback);
    }
    unsubscribeToSystemUnsubscribe(callback) {
        this._eventEmitter.off('unsubscribe', callback);
    }
    addIdea(idea) {
        this._eventEmitter.emit('add', idea);
    }
    cancelIdea(idea) {
        this._eventEmitter.emit('cancel', idea);
    }
    systemsChange(systemID) {
        this._eventEmitter.emit('change', systemID);
    }
    systemUnsubscribe(systemID) {
        this._eventEmitter.emit('unsubscribe', systemID);
    }
}
